export const environment = { 
  production: true,
  apiurl:'https://www.sajway.com/sajadmin/api/',
  imgurl:'https://www.sajway.com/sajadmin/public/storage/',
};

// export const environment = {
//    production: false,
//     apiurl:'https://sajway.com/development/sajadmin/api/',
//     imgurl:'https://sajway.com/development/sajadmin/public/storage/',
// };